/**
 * Event key codes
 */
export enum KeyCode {
  enter = 13,
  esc = 27,
  space = 32,
  leftArrow = 37,
  upArrow = 38,
  rightArrow = 39,
  downArrow = 40,
  tab = 9,
  shift = 16,
}
